import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PageCont, PerPageText, RowsPerPageCont } from './RowsPerPage.styles';
import { useSurveyTable } from '../../hooks';
import Select from '../Select/Select';

interface IRowsPerPage {
  itemsPerPage: number;
  pagesCount: number;
  menu: string[];
  customApplyFilters?: (filters: any) => void;
}

const RowsPerPage: FC<IRowsPerPage> = ({ itemsPerPage, pagesCount, menu, customApplyFilters }) => {
  const { t } = useTranslation();
  const { applyFilters } = useSurveyTable();
  const apply = customApplyFilters ? customApplyFilters : applyFilters;
  return (
    <PageCont>
      <RowsPerPageCont data-testid="rows-per-page-container">
        <PerPageText>{t('surveys.table.rowsPerPage.rowsPerPage')}:</PerPageText>
        <Select
          options={menu}
          selectedItem={`${itemsPerPage}`}
          onChange={(perPage: string[]) => apply({ perPage: perPage[0], pageNo: null })}
        />
      </RowsPerPageCont>
    </PageCont>
  );
};

export default RowsPerPage;
